<template>
  <div  style="max-height: 500px;min-height: 500px;overflow-y: auto;" >
    <hr class="mt-5 mb-3">
      <div v-show="Object.keys(selectedSensor).length === 0" class="flex justify-center">
          <p class="text-lg">{{$t("clickmarker")}}</p>
      </div>
      <div v-show="Object.keys(selectedSensor).length !== 0">
          <div class="flex justify-center items-center"><b>{{selectedSensor.name}}</b></div>
          
          <div class="flex justify-center items-center mb-4"><b>{{selectedSensor.description}}</b></div>
          <div  class="flex justify-center items-center" >
              <div v-bind:style="{backgroundColor:ColorCode}" class="rounded-full w-3 h-3 mr-4"></div>
              <div v-for="item in selectedSensor.statustext" :key="item.text">
                  {{item.text}}
                </div>
          </div>
      </div>
      <div>
        <SensorStatusGraphs :observations="last24hobservations" :H24Parameters="ssH24Parameters"></SensorStatusGraphs>
      </div>
      <div v-show="HasMeasurement">
        <button class="plotbtn" @click="onPlot">Plot data</button>
      </div>

      <div v-show="placementStatus">
        <div class="mt-5 font-bold">{{$t("mapinfo1")}}</div>
        <div class="flex flex-wrap content-start">
          <div class="mr-4"><img :src="require('@/assets/msmarker.png')" contain height="15px" width="15px"/></div>
          <div>{{$t("mapinfo2")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div class="mr-4"><img :src="require('@/assets/ssmarker.png')" contain height="15px" width="15px"/></div>
          <div>{{$t("mapinfo3")}}</div>
        </div>
        
        <div class="mt-5 font-bold"><div>{{$t("mapinfo4")}}</div></div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #0ab45a;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("mapinfo5")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #f9d53d;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("mapinfo6")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #aa0a3c;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("mapinfo7")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #606060;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("mapinfo8")}}</div>
        </div>
      </div>

      <div v-show="placementStatus">
        <div class="mt-5 font-bold"><div>{{$t("fanspeedinfo")}}</div></div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #0ab45a;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("fanspeedinfo1")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #f9d53d;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("fanspeedinfo2")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #aa0a3c;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("fanspeedinfo3")}}</div>
        </div>
        <div class="flex flex-wrap content-start">
          <div style="background-color: #606060;" class="rounded-full w-3 h-3 mr-4"></div>
          <div>{{$t("fanspeedinfo0")}}</div>
          <div class="flex flex-wrap content-start">
            <div style="background-color: #000000;" class="rounded-full w-3 h-3 mr-4"></div>
            <div>{{$t("fanspeedinfonull")}}</div>
          </div>
        </div>
      </div>

      <div v-show="measurementStatus">
        <div class="mt-5 font-bold"><div>{{$t("mapinfo9")}}</div></div>
        <div class="mt-2 grid grid-cols-4 gap-4">
          
          <div v-for="p in ssH24Parameters" :key="p.id" class="font-bold">
            {{ p.name }}
            <div class="flex flex-wrap content-start" v-for="(c, index) in colorCodesParameter(p.colorcodes)">
            <template v-if="c[0] !== -9999">
                <div v-bind:style="{backgroundColor: c[1]}" class="rounded-full w-3 h-3 mr-4"></div>
                {{ c[0] }}
                <!-- The next value to show the interval for which the color represents -->
                <div v-if="index !== colorCodesParameter(p.colorcodes).length - 1"> - {{ colorCodesParameter(p.colorcodes)[index + 1][0] }} </div>
              </template>
            </div>
          </div>
          <div></div>
        </div>
        <div class="mt-5 font-bold"><div>{{$t("availhourinfo1")}}</div></div>
        <div><div>{{$t("availhourinfo2")}}</div></div>
      </div>

  </div>
  
</template>

<script>

import MapboxglHelper from "../../../helpers/settings/mapboxgl";
import HighchartHelper from "../../../helpers/settings/highchart";
import PopupContent from './PopupContent';
import SensorStatusGraphs from './SensorStatusGraphs';
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import { LButton } from "@/components/forms";
import router from "../../../router"
import ApexchartHelper from "@/helpers/settings/apexchart";
import * as moment from "moment";

export default {
name: 'SensorStatus',
components: {
  PopupContent,
  SensorStatusGraphs
},
props: {
  ssfeature: {type: Object},
  selectedSensor:{type: Object},
  ssH24Parameters:[],
  measurementStatus:true,
  placementStatus:true,

},
data() {
  return {
    observations: [],
    last24hobservations: [],
    series: [],
    loading: false,
    localfeature: this.ssfeature,
    localselectedSensor: this.selectedSensor,
    chartsetting: HighchartHelper.xssettings(this.selectedSensor.name)
  };
},
mounted() {
  //Set plot bands
  this.chartsetting.chart.height = 200;
  if(this.selectedSensor.id){
    //Notify.loadData(null, this.loadInitialData);
    this.loadInitialData();
  }
},
filters: {
  epochToDate: function (epoch) {
    return moment.unix(epoch).utc().format('YYYY-MM-DD HH:mm') + "Z";
  }
},
methods: {
  async loadInitialData () {
    //Show last 24 hours data for main components
    let sensorcomps = [];

    this.ssH24Parameters.forEach(param => {
      sensorcomps.push({"SensorId" : this.ssfeature.properties.id, "SensorName": '', "Component": param.name, "ProviderId": this.ssfeature.properties.providerid});
    });

    this.last24hobservations = await ObservationsService.aggregeatedobservations(
      {
        From: moment().utc().subtract(24,"hours").unix(), 
        To: moment().unix(),
        ProviderId: this.ssfeature.properties.providerid,
        AggLevel: 'hourly',
        Sensors: sensorcomps
      }
    );

  },
  onPlot() {
    var plotsensors = [];
    plotsensors.push(this.selectedSensor);

    router.push({
        name: 'ObservationsPlot',
        params: {
            sensors: plotsensors
        }
    });
  },
  colorCodesParameter(param){
    return MapboxglHelper.sensorstatus.colorcodesparam[param];
  },
  cleargraphs(){

  }
},
computed:{
  ColorCode: function(){
      if(this.selectedSensor.id){
          return MapboxglHelper.sensorstatus.colorcodes[this.selectedSensor.statuscolor][1];
      } 
      return ""; 
  },
  HasMeasurement: function(){
    if(this.selectedSensor.id){
          return true;
      } 
      return false; 
  },
},
watch: {
  selectedSensor: function (newValue, oldValue) {
    this.loadInitialData();
  } 
}

};
</script>

<style lang="scss" scoped>

/* purgecss start ignore */
  .plotbtn{
    padding-top: 10px;
    padding-left: 10px;
    font-weight: bold;
    font-size: 14px;
    color: orangered;
  }
  ::-webkit-scrollbar {
    width: 20px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }  
  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
  /* purgecss end ignore */
</style>


